import { topicsData } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="w-full max-w-[1120px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-4">
          热门话题标签
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8">
          发现你感兴趣的漫画类型，点击标签探索更多精彩
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          {topicsData.map((t) => (
            <span
              key={t.label}
              className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm cursor-pointer transition-colors duration-200 whitespace-nowrap ${
                t.hot
                  ? 'bg-accent-100 text-accent-700 hover:bg-accent-200 font-medium'
                  : 'bg-background-50 border border-background-200/70 text-foreground-600 hover:border-background-300'
              }`}
            >
              {t.hot && <i className="ri-fire-line text-xs"></i>}
              {t.label}
              <span className="text-xs opacity-60">{t.count}</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}